import React, { memo } from 'react'
import { Path, Circle as _Circle } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M11.125 2.25C9.86938 2.25 8.755 2.74563 8 3.5975C7.245 2.74563 6.13062 2.25 4.875 2.25C3.78139 2.25132 2.73295 2.68635 1.95965 3.45965C1.18635 4.23295 0.751323 5.28139 0.75 6.375C0.75 10.8962 7.36312 14.5088 7.64437 14.6606C7.75367 14.7195 7.87586 14.7503 8 14.7503C8.12414 14.7503 8.24633 14.7195 8.35563 14.6606C8.63688 14.5088 15.25 10.8962 15.25 6.375C15.2487 5.28139 14.8137 4.23295 14.0404 3.45965C13.2671 2.68635 12.2186 2.25132 11.125 2.25ZM10.7819 11.1475C9.91142 11.8861 8.98091 12.5509 8 13.135C7.01909 12.5509 6.08858 11.8861 5.21812 11.1475C3.86375 9.98563 2.25 8.21375 2.25 6.375C2.25 5.67881 2.52656 5.01113 3.01884 4.51884C3.51113 4.02656 4.17881 3.75 4.875 3.75C5.9875 3.75 6.91875 4.3375 7.30562 5.28375C7.36193 5.42169 7.45805 5.53974 7.58172 5.62283C7.70539 5.70592 7.85101 5.7503 8 5.7503C8.14899 5.7503 8.29461 5.70592 8.41828 5.62283C8.54195 5.53974 8.63807 5.42169 8.69438 5.28375C9.08125 4.3375 10.0125 3.75 11.125 3.75C11.8212 3.75 12.4889 4.02656 12.9812 4.51884C13.4734 5.01113 13.75 5.67881 13.75 6.375C13.75 8.21375 12.1362 9.98563 10.7819 11.1475Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconHeart'

export const IconHeart = memo(themed(Icon))
